<!--
  结算模块
-->
<template>
  <div class="settle-container light-bg" ref="settleContain">
    <!--头部-->
    <titleHeader title="确认订单" :cunstom-back="true" @goback="goback"></titleHeader>
    <div class="settle-content">
      <!--选择收货地址-->
      <div class="address-box" @click="gotoSetAddress">
        <div v-show="hasAddress">
          <span class="address-username">{{ defaultAddress.name }} </span>
          <span class="address-tel">{{ defaultAddress.tel }}</span>
          <div class="address-detail">
            <!--          <span class="default-address">默认</span>-->
            {{ defaultAddress.addressDetail }}
          </div>
        </div>
        <span v-show="!hasAddress">选择收货地址</span>
        <van-icon class="goto-address" name="arrow" color="#acaaaa" size="20" />
      </div>
      <!--商品订单-->
      <div class="goods-list">
        <div v-for="item in cartList" class="supplier-item">
          <div class="supplier-header">
            <i class="iconfont icon-gongyingshang supplier-icon"></i>
            {{ item.supplierName }}
          </div>
          <div class="goods-detail" v-for="goods in item.goods">
            <img v-bind:src="goods.picUrl" alt="" class="goods-image" />
            <div class="goods-info">
              <div class="goods-name over3line">{{ goods.goodsName }}</div>
              <div class="goods-specifition">{{ goods.specificationNames }}</div>
              <goodsPrice
                :price="goods.price"
                color="#e93b3d"
                :main-size="16"
                style="display: inline-block;"
              ></goodsPrice>
              <!--如果从购物车页面进来结算，那么显示数量，否则显示数量选择组件-->
              <span class="goods-num" v-show="ifFromCart">×{{ goods.num }}</span>
              <inputNumber
                class="input-number"
                v-show="!ifFromCart"
                :number.sync="goods.selectedNum"
                :product-id="goods.id"
                :height="20"
              ></inputNumber>
            </div>
          </div>
          <!--分割线-->
          <div class="split-line"></div>
        </div>
      </div>
    </div>
    <!--底部提交订单-->
    <div class="bottom-btn">
      <div class="submit-btn" @click="submitOrder"><span>提交订单</span></div>
      <div class="goods-info-box">
        <span class="goods-num">共 {{ goodsNum }}件，</span>
        <span class="goods-price">合计</span>
        <goodsPrice :price="goodsPrice" color="#e93b3d" :main-size="16" style="display: inline-block;font-weight: bold;"></goodsPrice>
      </div>
    </div>
    <!--loading-->
    <van-loading class="data-loading" color="#45C5DA" size="40" type="spinner" v-show="showLoading" />
  </div>
</template>

<script>
import api from 'api/user';
import inputNumber from 'components/input-number';
import { getWxSign } from 'common/js/getSDKSign';
import wx from 'weixin-js-sdk';
import { mapMutations } from 'vuex';
import { Toast } from 'vant';
import { getToken } from 'common/js/ovoSystem';
export default {
  components: {
    inputNumber,
  },
  data() {
    return {
      cartList: [],
      ifFromCart: false,
      defaultAddress: {},
      addressIndex: -1,
      ifDetail: false, //是否是从商品详情页进入的订单
      showLoading: false,
      distributionUser: '', //分销员
      hasAddress: true, //是否设置了收货地址
    };
  },
  computed: {
    goodsNum() {
      //是否是从商品详情页进入的订单
      if (this.ifDetail) {
        return this.cartList[0].goods[0].selectedNum;
      } else {
        let count = 0;
        this.cartList.map(cart => {
          cart.goods.map(item => {
            count += Number(item.num);
          });
        });
        return count;
      }
    },
    goodsPrice() {
      //是否是从商品详情页进入的订单
      if (this.ifDetail) {
        return this.cartList[0].goods[0].price * this.cartList[0].goods[0].selectedNum;
      } else {
        let price = 0;
        this.cartList.map(cart => {
          cart.goods.map(item => {
            price += Number(item.price) * Number(item.num);
          });
        });
        return price;
      }
    },
  },
  created() {
    //微信签名
    getWxSign()
    //是否是从商品详情页进入的订单
    this.ifDetail = localStorage.getItem('settleType') == 1;
    this.getAddress();
    //从商品详情页跳转来的，订单就是该商品
    if (this.ifDetail) {
      const standard = JSON.parse(this.$route.query.standard);
      if (standard.distributionUser) this.distributionUser = standard.distributionUser;
      this.cartList = [standard];
      console.log(this.cartList);
    } else {
      this.getCarts();
      this.ifFromCart = true;
    }
  },
  mounted(){
    this.$refs['settleContain'].style.height = window.innerHeight + 'px';
  },
  methods: {
    //获取购物车
    async getCarts() {
      const data = await api.getCart();
      //从所有购物车商品中获取勾选的商品加入订单
      data.records.map((cart, index) => {
        const { supplierId, supplierName } = cart;
        this.cartList[index] = { supplierId, supplierName, goods: [] };
        this.cartList[index].goods = cart.shopCartList.filter(item => item.checked === 1);
      });
      this.cartList = this.cartList.filter(item => item.goods.length);
    },
    //获取收货地址
    async getAddress() {
      const data = await api.getAddress();
      if (data.records.length === 0) {
        this.hasAddress = false;
        return
      }
      if (this.$route.query.index != undefined) {
        this.addressIndex = this.$route.query.index;
        this.defaultAddress = data.records[this.addressIndex];
      } else {
        let hasDefault = false;//是否有默认收货地址
        data.records.map((item, index) => {
          if (item.isDefault === 1) {
            hasDefault = true;
            this.defaultAddress = item;
            this.addressIndex = index;
          }
        });
        if (!hasDefault) {
          this.defaultAddress = data.records[0];
          this.addressIndex = 0;
        }
      }
    },
    //跳转设置收货地址页面
    gotoSetAddress() {
      //设置是从订单页进入收货地址
      this.setAddressFrom('settle');
      let params = {
        index: this.addressIndex,
      };
      //需要把订单详情传过去，选择收货地址后再传回来
      if (this.$route.query.standard) {
        params.standard = this.$route.query.standard;
      }
      this.$router.push({
        path: '/address',
        query: params,
      });
    },
    //提交订单
    async submitOrder() {
      if (!this.defaultAddress.id) {
        this.$toast('请选择收货地址')
        return
      }
      this.showLoading = true;
      let orderMo = {
        userAddressId: this.defaultAddress.id,
      };
      if (this.ifDetail) {
        orderMo.num = this.cartList[0].goods[0].selectedNum;
        orderMo.productId = this.cartList[0].goods[0].id;
        orderMo.placeOrderType = 1;
      } else {
        orderMo.placeOrderType = 0;
      }
      //如果是从分销员的二维码购买的，则传分销员的id
      if (this.distributionUser) orderMo.shareUserId = Number(this.distributionUser);
      const data = await api.generateOrder(orderMo);
      this.showLoading = false;
      if(data === 'NO_NUM') {
        Toast.fail('该商品暂无库存')
        return
      }
      const token = getToken()
      window.location.href = `http://wdsxapi.ovopark.com/settle?type=1&orderSn=${data}&token=${token}`
    //  const sign = await api.payByJSSDK(data);
    //  let that = this;
    //   wx.chooseWXPay({
    //     timestamp: sign.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
    //     nonceStr: sign.nonceStr, // 支付签名随机串，不长于 32 位
    //     package: sign.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
    //     signType: sign.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
    //     paySign: sign.paySign, // 支付签名
    //     success: function (res) {
    //       // 支付成功后的回调函数
    //       console.log(res);
    //       that.$router.push({
    //         path: '/order-success',
    //         query: {
    //           orderNum: data,
    //         },
    //       });
    //     },
    //     cancel: function (res) {
    //       console.log(res);
    //       that.$router.push({
    //         path: '/order',
    //       });
    //     }
    //   });
    },
    //返回,不能用go(-1),因为从收货地址选择页跳转来的话，go(-1)会回到收货地址页，但这里不能返回到收货地址页，需要返回到触发订单页的页面（购物车或商品详情页）
    goback() {
      //从商品详情页来的
      if (localStorage.getItem('settleType') == 1) {
        this.$router.push({
          path: '/goods-detail',
          query: {
            goodsId: localStorage.getItem('goodsId'),
          },
        });
      } else {
        this.$router.push({
          name: 'shopCart',
        });
      }
    },
    ...mapMutations(['setAddressFrom'])
  },
};
</script>

<style scoped lang="scss">
@import 'common/sass/theme.scss';
.settle-container {
  .settle-content {
    height: calc(100% - #{$top-nav-height} - 50px);
    overflow: auto;
    //收货地址
    .address-box {
      position: relative;
      padding: 10px;
      margin-bottom: 9px;
      background: #fff;
      .address-username {
        font-weight: bold;
      }
      .address-tel {
        font-size: 14px;
        font-weight: bold;
      }
      .address-detail {
        font-size: 14px;
        color: $weight-word-color;
        .default-address {
          display: inline-block;
          padding: 0 5px;
          margin-right: 10px;
          font-size: 10px;
          color: $red-color;
          border: 1px solid $red-color;
          line-height: normal;
        }
      }
      .goto-address {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    //订单列表
    .goods-list {
      .supplier-item {
        background: #fff;
        margin-bottom: 15px;
        .supplier-header {
          height: 40px;
          padding: 0 10px;
          line-height: 40px;
          border-bottom: 1px solid $light-line-color;
          .supplier-icon {
            margin-right: 5px;
            color: $theme-color;
          }
        }
        .goods-detail {
          display: flex;
          padding: 10px;
          border-bottom: 1px solid $light-line-color;
          .goods-image {
            display: inline-block;
            width: 75px;
            height: 75px;
            margin-right: 10px;
          }
          .goods-info {
            flex: 1;
            overflow: hidden;
            .goods-name {
            }
            .goods-specifition {
              font-size: 12px;
              color: $light-color;
            }
            .goods-num {
              float: right;
              margin-left: 5px;
              color: $light-color;
              font-size: 12px;
            }
            .input-number {
              float: right;
            }
          }
        }
      }
    }
  }
  //底部
  .bottom-btn {
    display: flex;
    position: fixed;
    align-items: center;
    flex-direction: row-reverse;
    bottom: 0;
    width: 100vw;
    height: 50px;
    background: #fff;
    .goods-info-box {
      .goods-num {
        font-size: 13px;
        color: $light-color;
      }
      .goods-price {
        font-size: 14px;
      }
    }
    .submit-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 15px 0 5px;
      width: 100px;
      height: 40px;
      background: $theme-color;
      border-radius: 30px;
      line-height: 40px;
      color: #fff;
    }
  }
}
</style>
